import { Core } from "@faire/design-tokens";
import { MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE } from "@faire/retailer-visitor-shared/features/Marketplace/styleConsts";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled, { css } from "styled-components";
export var PaddedContainer = styled(Column).withConfig({
    componentId: "sc-3bddfeba-0"
})([
    "width:100%;max-width:1280px;margin:0 auto;",
    " ",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], function(props) {
    return props.$noPaddingOnMobile ? "" : css([
        "padding:",
        ";"
    ], getSpacing(0, "2x"));
}, responsiveMediaQueries.tabletAndAbove, getSpacing(0, "5x"), responsiveMediaQueries.desktopAndAbove, getSpacing(0, "10x"));
export var PaginationRow = styled(Row).attrs({
    align: "flex-start"
}).withConfig({
    componentId: "sc-3bddfeba-1"
})([
    "margin:0 -",
    "px;border-top:1px solid ",
    ";padding:",
    ";",
    "{margin:",
    ";}"
], MARKETPLACE_LEFT_AND_RIGHT_MARGIN_MOBILE, Core.border.muted, getSpacing("3x", 0), responsiveMediaQueries.tabletAndAbove, getSpacing("2x", 0, 0));
